module.exports = __webpack_public_path__ + "static/media/wrathgate.dee8e75e.jpg";